__turbopack_context__.v({
  "root": "ProductServices-module-scss-module__AVpLWG__root",
});
